import React, { Component } from "react";
import { observer } from "mobx-react";
import home from "../../store/index.js";
import First from "../FirstEntry/index";
import Seconed from "../ScondEnter/index";
import { browlog } from "../../static/js/http";
import Tap from "../tap/index";
import Mainstructure from "../Mainstructure/index";

// Mainstructure
import "./index.css";
import Loading from "../Loading/index.js";
import logo from "../../static/images/logo.png";
import CallApp from "callapp-lib";
const options = {
  scheme: {
    protocol: "lenovocochat://",
    host: "lncochat",
  },
  intent: {
    package: "com.samsundot.talking",
    scheme: "lenovocochat",
  },
  appstore:
    "lenovocochat://lncochat?url=https://apps.cochat.lenovo.com/careerConfusing/#/",
  yingyongbao:
    "lenovocochat://lncochat?url=https://apps.cochat.lenovo.com/careerConfusing/#/",
  fallback:
    "lenovocochat://lncochat?url=https://apps.cochat.lenovo.com/careerConfusing/#/",
};
const callLib = new CallApp(options);

@observer
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      weixin: false,
      web: false,
    };
  }

  componentDidMount() {
    let u = navigator.userAgent.toLocaleLowerCase();
    if (u.indexOf("micromessenger") !== -1) {
      this.setState({ weixin: true, show: true });
    } else {
      if (navigator.userAgent.includes("cochat")) {
        home.login();
        let log = sessionStorage.getItem("browlog");
        if (!log) {
          //数据统计
          browlog();
        }
      } else {
        this.setState({ show: true });
        callLib.open({
          path: "",
        });
      }
    }
  }
  render() {
    return (
      <div>
        {!this.state.show ? (
          <div className="home">
            {!home.isExisted && !home.loginSecond ? <First /> : ""}
            {home.loginSecond ? <Seconed /> : ""}
            {home.isExisted && !home.isLoading ? <Mainstructure /> : ""}
            {home.isExisted && !home.isLoading ? <Tap /> : ""}
            {home.isLoading ? <Loading /> : ""}
          </div>
        ) : (
          <div className="noCochat">
            {this.state.weixin ? (
              <div>
                <div className="noCochatTp">
                  <div className="noCochatTpL">
                    <a href="lenovocochat://">使用乐聊APP访问</a>
                    <p>请点击右上角…</p>
                    <p>选择在浏览器中打开</p>
                  </div>
                  <div className="noCochatTpR"></div>
                </div>
                <div className="noCochatbt">
                  <a href="lenovocochat://">
                    <img src={logo} alt="" />
                    <p>联想员工内部办公平台</p>
                  </a>
                </div>
              </div>
            ) : (
              <div className="micromessenger">
                <div className="micromessengerT">
                  <img src={logo} alt="" />
                  <p>联想员工内部办公平台</p>
                </div>
                <div className="openCoChat">
                  <a href="lenovocochat://lncochat?url=https://apps.cochat.lenovo.com/careerConfusing/#/">
                    点击唤起乐聊
                  </a>
                </div>
                <div className="micromessengerB">
                  <p>未安装乐聊？</p>
                  <a href="https://cochat.lenovo.com/#/">去下载</a>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}
export default Home;
